import { Home, Calendar, Inbox, User, LayoutGrid } from 'lucide-react';
import { NavLink } from 'react-router-dom';

interface TabItem {
    to: string;
    icon: React.ElementType;
    label: string;
}

const tabs: TabItem[] = [
    { to: '/app', icon: Home, label: 'Today' },
    { to: '/app/command-center', icon: LayoutGrid, label: 'Command' },
    { to: '/app/calendar', icon: Calendar, label: 'Calendar' },
    { to: '/app/inbox', icon: Inbox, label: 'Inbox' },
    { to: '/app/profile', icon: User, label: 'Profile' },
];

export default function TabBar() {
    return (
        <div className="bg-white dark:bg-[#1A2832] shadow-[0_-2px_8px_rgba(13,95,107,0.06),0_-1px_2px_rgba(13,95,107,0.04)] dark:shadow-[0_-2px_8px_rgba(0,0,0,0.3)]">
            <nav className="flex justify-around py-3 px-2">
                {tabs.map((tab) => (
                    <NavLink
                        key={tab.to}
                        to={tab.to}
                        end={tab.to === '/app'}
                        className={({ isActive }) =>
                            `flex flex-1 flex-col items-center gap-1 ${isActive ? 'text-[#1A2832] dark:text-white' : 'text-[#7B8C9B] dark:text-[#6B7C8C]'
                            }`
                        }
                    >
                        {({ isActive }) => (
                            <>
                                <div className="w-6 h-6 flex items-center justify-center">
                                    <tab.icon
                                        className={`w-6 h-6 ${isActive ? 'text-[#1A2832] dark:text-white' : 'text-[#7B8C9B] dark:text-[#6B7C8C]'
                                            }`}
                                    />
                                </div>
                                <span className="text-xs font-normal">{tab.label}</span>
                            </>
                        )}
                    </NavLink>
                ))}
            </nav>
            {/* Bottom Safe Area */}
            <div className="h-[env(safe-area-inset-bottom,0px)]"></div>
        </div>
    );
}
